module.exports = __webpack_public_path__ + "img/signup.ce777c1b.png";